import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CacheService } from './cache.service';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ],
  providers: [CacheService]
})
export class CacheModule { }
